var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._t("title")],2),_c('v-card-text',[_c('div',{staticClass:"display-1 mb-4"},[_vm._t("price")],2),_vm._t("description")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }